// extracted by mini-css-extract-plugin
export var item = "Sensors-module--item--1798d";
export var itemImg = "Sensors-module--item-img--f79f2";
export var list = "Sensors-module--list--ef6b2";
export var subtitle = "Sensors-module--subtitle--59895";